import { useMutation } from '@tanstack/react-query'
import { agentsApi, type AgentInstallerPlatform } from '../../api/agents-api'
import { pskKeys } from '../../api/query-keys'

export function useCreateAgentPsk(entityId: string) {
  return useMutation({
    mutationFn: (options: { maxUses?: number; expiresAt?: string }) =>
      agentsApi.createEntityAgentPsk(entityId, options),
    meta: { invalidates: [pskKeys.root] },
  })
}

export function useDownloadAgentInstaller(entityId: string) {
  return useMutation({
    mutationFn: ({ platform, maxUses }: { platform: AgentInstallerPlatform; maxUses: number }) =>
      agentsApi.downloadEntityAgentInstaller(entityId, platform, maxUses),
    meta: { invalidates: [pskKeys.root] },
  })
}
